import {
  CLEAR_WORKFLOW_HISTORY,
  UPDATE_APPROVER_HISTORY,
  UPDATE_WORKFLOW_HISTORY,
  FETCH_WORKFLOW_HISTORY,
  FETCH_WORKFLOW_HISTORY_START,
  FETCH_WORKFLOW_HISTORY_SUCCESS,
  FETCH_WORKFLOW_HISTORY_ERROR,
  FETCH_APPROVER_HISTORY,
  FETCH_APPROVER_HISTORY_START,
  FETCH_APPROVER_HISTORY_SUCCESS,
  FETCH_APPROVER_HISTORY_ERROR,
  FETCH_HISTORY,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const clearWorkflowHistory = () => ({ type: CLEAR_WORKFLOW_HISTORY })
const updateApproverHistory = (history) => ({ type: UPDATE_APPROVER_HISTORY, history })
const updateWorkflowHistory = (history) => ({ type: UPDATE_WORKFLOW_HISTORY, history })
const fetchWorkflowHistory = (workflowId) => ({ type: FETCH_WORKFLOW_HISTORY, workflowId })
const fetchWorkflowHistoryStart = () => ({ type: FETCH_WORKFLOW_HISTORY_START })
const fetchWorkflowHistorySuccess = (history) => ({ type: FETCH_WORKFLOW_HISTORY_SUCCESS, history })
const fetchWorkflowHistoryError = (error) => ({ type: FETCH_WORKFLOW_HISTORY_ERROR, error })
const fetchApproverHistory = (workflowId) => ({ type: FETCH_APPROVER_HISTORY, workflowId })
const fetchApproverHistoryStart = () => ({ type: FETCH_APPROVER_HISTORY_START })
const fetchApproverHistorySuccess = (history) => ({ type: FETCH_APPROVER_HISTORY_SUCCESS, history })
const fetchApproverHistoryError = (error) => ({ type: FETCH_APPROVER_HISTORY_ERROR, error })
const fetchHistory = (workflowId) => ({ type: FETCH_HISTORY, workflowId })
const startFetchApproverHistoryAsync = buildAsyncAction(
  FETCH_APPROVER_HISTORY,
  FETCH_APPROVER_HISTORY_START,
  [ FETCH_APPROVER_HISTORY_ERROR, FETCH_APPROVER_HISTORY_SUCCESS ]
)
const startFetchWorkflowHistoryAsync = buildAsyncAction(
  FETCH_WORKFLOW_HISTORY,
  FETCH_WORKFLOW_HISTORY_START,
  [ FETCH_WORKFLOW_HISTORY_ERROR, FETCH_WORKFLOW_HISTORY_SUCCESS ]
)

export {
  startFetchApproverHistoryAsync,
  startFetchWorkflowHistoryAsync,
  clearWorkflowHistory,
  updateApproverHistory,
  updateWorkflowHistory,
  fetchWorkflowHistory,
  fetchWorkflowHistoryStart,
  fetchWorkflowHistorySuccess,
  fetchWorkflowHistoryError,
  fetchApproverHistory,
  fetchApproverHistoryStart,
  fetchApproverHistorySuccess,
  fetchApproverHistoryError,
  fetchHistory,
}
